export const pattern3Data = [
  {
    id: 1,
    koreanChunks: [
      "그 회사는",
      "제공했다",
      "상세한 정보를",
      "다가오는 변화에 대한",
      "기업 구조의",
    ],
    englishChunks: [
      "The company",
      "provided",
      "detailed information",
      "about the upcoming changes",
      "in the corporate structure",
    ],
    fullEnglish:
      "The company provided detailed information about the upcoming changes in the corporate structure.",
    explanation:
      "주어(S) + 동사(V) + 목적어(O) 구조의 3형식 문장입니다. 목적어 뒤에 전치사구가 추가되어 의미를 구체화합니다.",
  },
  {
    id: 2,
    koreanChunks: [
      "공급업체는",
      "배달했다",
      "대량 선적을",
      "고품질 전자 부품",
      "제조 공장에",
    ],
    englishChunks: [
      "The supplier",
      "delivered",
      "a large shipment",
      "of high-quality electronic components",
      "to the manufacturing plant",
    ],
    fullEnglish:
      "The supplier delivered a large shipment of high-quality electronic components to the manufacturing plant.",
    explanation:
      "주어(S) + 동사(V) + 목적어(O) 구조의 3형식 문장입니다. 목적어 뒤에 전치사구가 추가되어 의미를 구체화합니다.",
  },
  {
    id: 3,
    koreanChunks: [
      "인사부는",
      "보냈다",
      "공식 발표를",
      "조정에 대한",
      "직원 복지 및 보상",
    ],
    englishChunks: [
      "The HR department",
      "sent",
      "an official announcement",
      "regarding the adjustments",
      "in employee benefits and compensation",
    ],
    fullEnglish:
      "The HR department sent an official announcement regarding the adjustments in employee benefits and compensation.",
    explanation:
      "주어(S) + 동사(V) + 목적어(O) 구조의 3형식 문장입니다. 목적어 뒤에 전치사구가 추가되어 의미를 구체화합니다.",
  },
  {
    id: 4,
    koreanChunks: [
      "매니저는",
      "제공했다",
      "종합적인 교육 프로그램을",
      "향상시키기 위해",
      "리더십 스킬을",
      "새롭게 승진한 팀장들",
    ],
    englishChunks: [
      "The manager",
      "offered",
      "a comprehensive training program",
      "to enhance",
      "the leadership skills",
      "of newly promoted team leaders",
    ],
    fullEnglish:
      "The manager offered a comprehensive training program to enhance the leadership skills of newly promoted team leaders.",
    explanation:
      "주어(S) + 동사(V) + 목적어(O) 구조의 3형식 문장입니다. 목적어 뒤에 부사적 용법의 to부정사구가 추가되어 목적을 나타냅니다.",
  },
  {
    id: 5,
    koreanChunks: [
      "IT 부서는",
      "부여했다",
      "이용권한을",
      "새롭게 개발된 클라우드 스토리지 시스템",
      "모든 직원들에게",
      "조직 내",
    ],
    englishChunks: [
      "The IT department",
      "granted",
      "access",
      "to the newly developed cloud storage system",
      "to all employees",
      "in the organization",
    ],
    fullEnglish:
      "The IT department granted access to the newly developed cloud storage system to all employees in the organization.",
    explanation:
      "주어(S) + 동사(V) + 목적어(O) 구조의 3형식 문장입니다. 목적어 뒤에 두 개의 전치사구가 추가되어 의미를 구체화합니다.",
  },
  {
    id: 6,
    koreanChunks: [
      "CEO는",
      "설명했다",
      "전략적 계획",
      "글로벌 확장에 대한",
      "그리고",
      "어떻게 그것이 영향을 미칠지",
      "회사의 장기적 성장에",
    ],
    englishChunks: [
      "The CEO",
      "explained",
      "the strategic plan",
      "for global expansion",
      "and",
      "how it will impact",
      " the company's long-term growth",
    ],
    fullEnglish:
      "The CEO explained the strategic plan for global expansion and how it will impact the company's long-term growth.",
    explanation:
      "주어(S) + 동사(V) + 목적어(O) 구조의 3형식 문장입니다. 목적어가 복합적인 내용을 포함하고 있습니다.",
  },
  {
    id: 7,
    koreanChunks: [
      "대변인은",
      "발표했다",
      "출시를",
      "혁신적 제품",
      "그..결합하는  인공지능과 스마트홈 기술을 ",
    ],
    englishChunks: [
      "The spokesperson",
      "announced",
      "the launch",
      "of an innovative product",
      "that integrates artificial intelligence with smart home technology",
    ],
    fullEnglish:
      "The spokesperson announced the launch of an innovative product that integrates artificial intelligence with smart home technology.",
    explanation:
      "주어(S) + 동사(V) + 목적어(O) 구조의 3형식 문장입니다. 목적어를 관계절이 수식하여 의미를 구체화합니다.",
  },
  {
    id: 8,
    koreanChunks: [
      "연구팀은",
      "설명했다",
      "결과를 1년간의 연구 ",
      "소비자 행동에 대한",
      "전자상거래 산업에서",
    ],
    englishChunks: [
      "The research team",
      "described",
      "the results of the year-long study",
      "on consumer behavior",
      "in the e-commerce industry",
    ],
    fullEnglish:
      "The research team described the results of the year-long study on consumer behavior in the e-commerce industry.",
    explanation:
      "주어(S) + 동사(V) + 목적어(O) 구조의 3형식 문장입니다. 목적어 뒤에 전치사구가 추가되어 연구 주제를 구체화합니다.",
  },
  {
    id: 9,
    koreanChunks: [
      "정부 기관은",
      "요청했다",
      "철저한 검토를",
      "환경 영향 평가 보고서",
      "새로운 인프라 프로젝트에 대한",
    ],
    englishChunks: [
      "The government agency",
      "requested",
      "a thorough review",
      "of the environmental impact assessment report",
      "for the new infrastructure project",
    ],
    fullEnglish:
      "The government agency requested a thorough review of the environmental impact assessment report for the new infrastructure project.",
    explanation:
      "주어(S) + 동사(V) + 목적어(O) 구조의 3형식 문장입니다. 목적어 뒤에 전치사구가 추가되어 검토 대상을 명확히 합니다.",
  },
  {
    id: 10,
    koreanChunks: [
      "부서장은",
      "언급했다",
      "중요성을",
      "유지하는것 강력한 협력",

      "다양한 팀 간에",
      "향상시키기 위해 생산성을",
    ],
    englishChunks: [
      "The department head",
      "mentioned",
      "the importance",
      "of maintaining strong collaboration",
      "between different teams",
      "to improve productivity",
    ],
    fullEnglish:
      "The department head mentioned the importance of maintaining strong collaboration between different teams to improve productivity.",
    explanation:
      "주어(S) + 동사(V) + 목적어(O) 구조의 3형식 문장입니다. 목적어 뒤에 부사적 용법의 to부정사구가 추가되어 목적을 나타냅니다.",
  },
  {
    id: 11,
    koreanChunks: [
      "이사회 구성원들은",
      "믿고 있다",
      "그... 도입하는것 유연한 재택근무 정책",
      "크게 향상시킬 것이라고",
      "직원 만족도와 생산성을",
    ],
    englishChunks: [
      "The board members",
      "believe",
      "that implementing a flexible work-from-home policy",
      "will significantly boost",
      "employee satisfaction and productivity",
    ],
    fullEnglish:
      "The board members believe that implementing a flexible work-from-home policy will significantly boost employee satisfaction and productivity.",
    explanation:
      "주어(S) + 동사(V) + 목적어(O) 구조의 3형식 문장입니다. 목적어로 that절이 사용되어 믿음의 내용을 설명합니다.",
  },
  {
    id: 12,
    koreanChunks: [
      "재무 분석가는",
      "고려했다",
      "장기적인 영향이",
      "인플레이션과 금리 인상",
      "글로벌 투자 시장에 미치는",
    ],
    englishChunks: [
      "The financial analyst",
      "considered",
      "the long-term impact",
      "of inflation and interest rate hikes",
      "on global investment markets",
    ],
    fullEnglish:
      "The financial analyst considered the long-term impact of inflation and interest rate hikes on global investment markets.",
    explanation:
      "주어(S) + 동사(V) + 목적어(O) 구조의 3형식 문장입니다. 목적어 뒤에 전치사구가 추가되어 영향의 내용을 구체화합니다.",
  },
  {
    id: 13,
    koreanChunks: [
      "채용 매니저는",
      "인식했다",
      "가치를",
      "채용하는 것 후보자를",
      "다양한 직업적 배경과 산업 전문성을 가진",
    ],
    englishChunks: [
      "The hiring manager",
      "recognized",
      "the value",
      "of hiring candidates",
      "with diverse professional backgrounds and industry expertise",
    ],
    fullEnglish:
      "The hiring manager recognized the value of hiring candidates with diverse professional backgrounds and industry expertise.",
    explanation:
      "주어(S) + 동사(V) + 목적어(O) 구조의 3형식 문장입니다. 목적어 뒤에 전치사구가 추가되어 가치의 대상을 설명합니다.",
  },
  {
    id: 14,
    koreanChunks: [
      "그녀는",
      "이해한다",
      "어려움을",
      "확장하는 데 따르는",
      "사업을",
      "국제 시장으로",
      "서로 다른 규제 요건을 가진",
    ],
    englishChunks: [
      "She",
      "understands",
      "the challenges",
      "associated with expanding",
      "a business",
      "into international markets",
      "with different regulatory requirements",
    ],
    fullEnglish:
      "She understands the challenges associated with expanding a business into international markets with different regulatory requirements.",
    explanation:
      "주어(S) + 동사(V) + 목적어(O) 구조의 3형식 문장입니다. 목적어 뒤에 분사구가 추가되어 어려움의 내용을 구체화합니다.",
  },
  {
    id: 15,
    koreanChunks: [
      "이사는",
      "기억했다",
      "긍정적인 피드백을",
      "이전 교육 프로그램에서 받은",
    ],
    englishChunks: [
      "The director",
      "remembered",
      "the positive feedback",
      "from the previous training program",
    ],
    fullEnglish:
      "The director remembered the positive feedback from the previous training program and decided to implement a similar course for new employees.",
    explanation:
      "주어(S) + 동사(V) + 목적어(O) 구조의 3형식 문장입니다. 목적어 뒤에 전치사구가 추가되어 피드백의 출처를 명시합니다.",
  },
  {
    id: 16,
    koreanChunks: [
      "엔지니어링 팀은",
      "완료했다",
      "개발을",
      "매우 효율적이고 친환경적인 에너지 저장 시스템",
    ],
    englishChunks: [
      "The engineering team",
      "completed",
      "the development",
      "of a highly efficient and environmentally friendly energy storage system",
    ],
    fullEnglish:
      "The engineering team completed the development of a highly efficient and environmentally friendly energy storage system.",
    explanation:
      "주어(S) + 동사(V) + 목적어(O) 구조의 3형식 문장입니다. 목적어 뒤에 전치사구가 추가되어 개발 대상을 구체화합니다.",
  },
  {
    id: 17,
    koreanChunks: ["IT 부서는", "처리했다", "사이버 보안 침해를", "효율적으로"],
    englishChunks: [
      "The IT department",
      "handled",
      "the cybersecurity breach",
      "efficiently",
    ],
    fullEnglish:
      "The IT department handled the cybersecurity breach efficiently.",
    explanation:
      "주어(S) + 동사(V) + 목적어(O) 구조의 3형식 문장입니다. 목적어 뒤에 부사가 추가되어 처리 방식을 설명합니다.",
  },
  {
    id: 18,
    koreanChunks: [
      "연구팀은",
      "이루었다",
      "상당한 진전을",
      "비용 효율적 솔루션을 개발하는 것에서",
      "재생 가능 에너지 저장을 위한 ",
    ],
    englishChunks: [
      "The research team",
      "achieved",
      "significant progress",
      "in developing a cost-effective solution",
      "for renewable energy storage",
    ],
    fullEnglish:
      "The research team achieved significant progress in developing a cost-effective solution for renewable energy storage.",
    explanation:
      "주어(S) + 동사(V) + 목적어(O) 구조의 3형식 문장입니다. 목적어 뒤에 전치사구가 추가되어 진전의 분야를 구체화합니다.",
  },
  {
    id: 19,
    koreanChunks: [
      "그 부서는",
      "필요로 한다",
      "추가 자원을",
      "충족시키기 위해 증가하는 수요를 ",
      "이것의 서비스를 위해",
    ],
    englishChunks: [
      "The department",
      "requires",
      "additional resources",
      "to meet the increasing demand",
      "for its services",
    ],
    fullEnglish:
      "The department requires additional resources to meet the increasing demand for its services.",
    explanation:
      "주어(S) + 동사(V) + 목적어(O) 구조의 3형식 문장입니다. 목적어 뒤에 to부정사구가 추가되어 목적을 나타냅니다.",
  },
  {
    id: 20,
    koreanChunks: [
      "노동 조합은",
      "요구했다",
      "공정한 임금과 더 나은 근무 환경을",
      "모든 직원에게",
    ],
    englishChunks: [
      "The labor union",
      "demanded",
      "fair wages and better working conditions",
      "for all employees",
    ],
    fullEnglish:
      "The labor union demanded fair wages and better working conditions for all employees.",
    explanation:
      "주어(S) + 동사(V) + 목적어(O) 구조의 3형식 문장입니다. 목적어 뒤에 전치사구가 추가되어 대상을 명확히 합니다.",
  },
  {
    id: 21,
    koreanChunks: [
      "프로젝트 매니저는",
      "요청했다",
      "연장을 마감기한",
      "보장하기 위해 더 높은 품질의 작업을 ",
    ],
    englishChunks: [
      "The project manager",
      "asked for",
      "an extension of the deadline",
      "to ensure higher quality work",
    ],
    fullEnglish:
      "The project manager asked for an extension of the deadline to ensure higher quality work.",
    explanation:
      "주어(S) + 동사(V) + 목적어(O) 구조의 3형식 문장입니다. 목적어 뒤에 to부정사구가 추가되어 목적을 설명합니다.",
  },
  {
    id: 22,
    koreanChunks: [
      "CEO는",
      "기대한다",
      "새로운 마케팅 캠페인이",
      "창출할 것으로 더 높은 수익을",
      "다음 분기에",
    ],
    englishChunks: [
      "The CEO",
      "expects",
      "the new marketing campaign",
      "to generate higher revenue",
      "in the next quarter",
    ],
    fullEnglish:
      "The CEO expects the new marketing campaign to generate higher revenue in the next quarter.",
    explanation:
      "주어(S) + 동사(V) + 목적어(O) 구조의 3형식 문장입니다. 목적어 뒤에 to부정사구가 추가되어 기대하는 내용을 구체화합니다.",
  },
  {
    id: 23,
    koreanChunks: [
      "그 회사는",
      "필요로 한다",
      "포괄적인 지속 가능성 전략을",
      "부합하는 글로벌 환경 기준과 ",
    ],
    englishChunks: [
      "The company",
      "needs",
      "a comprehensive sustainability strategy",
      "to align with global environmental standards",
    ],
    fullEnglish:
      "The company needs a comprehensive sustainability strategy to align with global environmental standards.",
    explanation:
      "주어(S) + 동사(V) + 목적어(O) 구조의 3형식 문장입니다. 목적어 뒤에 to부정사구가 추가되어 전략의 목적을 설명합니다.",
  },
  {
    id: 24,
    koreanChunks: [
      "그 회사는",
      "도입했다",
      "새로운 고객 관계 관리 시스템을",
      "강화하기 위해 고객과의 소통 및 참여",
    ],
    englishChunks: [
      "The company",
      "implemented",
      "a new customer relationship management system",
      "to enhance communication and engagement with clients",
    ],
    fullEnglish:
      "The company implemented a new customer relationship management system to enhance communication and engagement with clients.",
    explanation:
      "주어(S) + 동사(V) + 목적어(O) 구조의 3형식 문장입니다. 목적어 뒤에 to부정사구가 추가되어 도입 목적을 설명합니다.",
  },
  {
    id: 25,
    koreanChunks: [
      "마케팅 팀은",
      "수립했다",
      "종합적인 소셜 미디어 전략을",
      "높이기 위해 브랜드 인지도와 고객 참여를",
    ],
    englishChunks: [
      "The marketing team",
      "created",
      "a comprehensive social media strategy",
      "to increase brand awareness and customer engagement",
    ],
    fullEnglish:
      "The marketing team created a comprehensive social media strategy to increase brand awareness and customer engagement.",
    explanation:
      "주어(S) + 동사(V) + 목적어(O) 구조의 3형식 문장입니다. 목적어 뒤에 to부정사구가 추가되어 전략의 목적을 설명합니다.",
  },
  {
    id: 26,
    koreanChunks: [
      "그 회사는",
      "수정했다",
      "복장 규정을",
      "받은 후 직원들 피드백",
    ],
    englishChunks: [
      "The company",
      "revised",
      "its dress code policy",
      "after receiving employee feedback",
    ],
    fullEnglish:
      "The company revised its dress code policy after receiving employee feedback.",
    explanation:
      "주어(S) + 동사(V) + 목적어(O) 구조의 3형식 문장입니다. 목적어 뒤에 분사구문이 추가되어 수정의 시점을 설명합니다.",
  },
  {
    id: 27,
    koreanChunks: [
      "채용 담당자는",
      "예약했다",
      "최종 면접을",
      "최종 후보자들을 위해",
    ],
    englishChunks: [
      "The hiring manager",
      "scheduled",
      "final interviews",
      "for the top candidates",
    ],
    fullEnglish:
      "The hiring manager scheduled final interviews for the top candidates.",
    explanation:
      "주어(S) + 동사(V) + 목적어(O) 구조의 3형식 문장입니다. 목적어 뒤에 전치사구가 추가되어 면접 대상을 설명합니다.",
  },
  {
    id: 28,
    koreanChunks: [
      "인사팀은",
      "처리했다",
      "환급 요청들을",
      "직원들로부터",
      "그... 참석한 컨퍼런스에",
    ],
    englishChunks: [
      "The HR team",
      "processed",
      "reimbursement requests",
      "from employees",
      "who attended the conference",
    ],
    fullEnglish:
      "The HR team processed reimbursement requests from employees who attended the conference.",
    explanation:
      "주어(S) + 동사(V) + 목적어(O) 구조의 3형식 문장입니다. 목적어 뒤에 전치사구가 추가되어 요청의 출처를 설명합니다.",
  },
  {
    id: 29,
    koreanChunks: ["관광 산업은", "경험했다", "수요 급증을", "휴가 시즌 동안"],
    englishChunks: [
      "The tourism industry",
      "experienced",
      "a surge in demand",
      "during the holiday season",
    ],
    fullEnglish:
      "The tourism industry experienced a surge in demand during the holiday season.",
    explanation:
      "주어(S) + 동사(V) + 목적어(O) 구조의 3형식 문장입니다. 목적어 뒤에 전치사구가 추가되어 수요 급증이 발생한 시기를 설명합니다.",
  },
  {
    id: 30,
    koreanChunks: [
      "여러 기업들이",
      "확장했다",
      "그들의 사업 운영을",
      "동남아시아로 작년에",
    ],
    englishChunks: [
      "Several corporations",
      "expanded",
      "their operations",
      "to Southeast Asia last year",
    ],
    fullEnglish:
      "Several corporations expanded their operations to Southeast Asia last year.",
    explanation:
      "주어(S) + 동사(V) + 목적어(O) 구조의 3형식 문장입니다. 목적어 뒤에 전치사구가 추가되어 확장의 방향과 시기를 설명합니다.",
  },
  {
    id: 31,
    koreanChunks: [
      "지역 사업체들이",
      "보고했다",
      "감소를",
      "고객 통행량",
      "도로 공사가 시작된 이후",
    ],
    englishChunks: [
      "Local businesses",
      "reported",
      "a decline",
      "in customer traffic",
      "after the road construction began",
    ],
    fullEnglish:
      "Local businesses reported a decline in customer traffic after the road construction began.",
    explanation:
      "주어(S) + 동사(V) + 목적어(O) 구조의 3형식 문장입니다. 목적어 뒤에 부사구가 추가되어 감소가 발생한 시점을 설명합니다.",
  },
  {
    id: 32,
    koreanChunks: [
      "의료팀이",
      "조사했다",
      "영향을",
      "장시간 화면 사용시간",
      "눈건강에 미치는",
      "최근에",
    ],
    englishChunks: [
      "The medical team",
      "examined",
      "the effects",
      "of prolonged screen time",
      " on eye health",
      "recently",
    ],
    fullEnglish:
      "The medical team examined the effects of prolonged screen time on eye health.",
    explanation:
      "주어(S) + 동사(V) + 목적어(O) 구조의 3형식 문장입니다. 목적어가 긴 명사구 형태로 구성되어 있습니다.",
  },
  {
    id: 33,
    koreanChunks: [
      "기술 회사가",
      "특허를 받았다",
      "새로운 소재를",
      "그.. 향상시키는 배터리 수명을",
    ],
    englishChunks: [
      "The tech company",
      "patented",
      "a new material",
      "that enhances battery life",
    ],
    fullEnglish:
      "The tech company patented a new material that enhances battery life.",
    explanation:
      "주어(S) + 동사(V) + 목적어(O) 구조의 3형식 문장입니다. 목적어가 관계절을 포함한 명사구로 구성되어 있습니다.",
  },
  {
    id: 34,
    koreanChunks: ["박물관이", "공개했다", "새로 복원된 그림", "18세기부터"],
    englishChunks: [
      "The museum",
      "unveiled",
      "a newly restored painting",
      "from the 18th century",
    ],
    fullEnglish:
      "The museum unveiled a newly restored painting from the 18th century.",
    explanation:
      "주어(S) + 동사(V) + 목적어(O) 구조의 3형식 문장입니다. 목적어가 형용사구로 수식된 명사구 형태로 구성되어 있습니다.",
  },
  {
    id: 35,
    koreanChunks: [
      "그 방송 네트워크가",
      "체결했다",
      "독점 계약을",
      "유명 저널리스트와",
    ],
    englishChunks: [
      "The broadcasting network",
      "signed",
      "an exclusive contract",
      "with a famous journalist",
    ],
    fullEnglish:
      "The broadcasting network signed an exclusive contract with a famous journalist.",
    explanation:
      "주어(S) + 동사(V) + 목적어(O) 구조의 3형식 문장입니다. 목적어 뒤에 전치사구가 추가되어 계약의 대상을 명시합니다.",
  },
  {
    id: 36,
    koreanChunks: [
      "시 공무원들이",
      "시행했다",
      "더 엄격한 규제를",
      "옥외 광고에 대한",
    ],
    englishChunks: [
      "City officials",
      "implemented",
      "stricter regulations",
      "on outdoor advertising",
    ],
    fullEnglish:
      "City officials implemented stricter regulations on outdoor advertising.",
    explanation:
      "주어(S) + 동사(V) + 목적어(O) 구조의 3형식 문장입니다. 목적어 뒤에 전치사구가 추가되어 규제의 대상을 구체화합니다.",
  },
];
